<template>
<div class="chapter">
<div class="inner_page">
<p class="h1"><a id="page_3"></a>Sea Monsters</p>
<p class="sub">A VOYAGE AROUND THE WORLD’S MOST BEGUILING MAP</p>
<p class="imagec"><img alt="image" src="images/common.jpg"/></p>
<p class="author"><b>JOSEPH NIGG</b></p>
<p class="pub">T H E   U N I V E R S I T Y   O F   C H I C A G O   P R E S S</p>
<p class="pub1">Chicago and London</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?62adebde